import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { EsnEvaluationService } from './../../../../core/services/esn-evaluation/esn-evaluation.service';
import { Component, TemplateRef } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import {
  addedCra,
  confirmDelete,
  deletedCra,
  existedCra,
  failedDelete,
  serverError,
  updatedCra,
} from './../../../../core/models/messages';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import Swal from 'sweetalert2';
import { PageEvent } from '@angular/material/paginator';
@Component({
  selector: 'app-type-activity-cra',
  templateUrl: './type-activity-cra.component.html',
  styleUrls: ['./type-activity-cra.component.css'],
})
export class TypeActivityCraComponent {
  parentItem = 'Oups, Aucune donnée disponible pour le moment.';
  btnSearchactive : boolean = false;
  /* numbers */
  currentPage: number = 0;
  pageSize = 5;
  pageSizeOptions = [5, 10, 20];
  totalItems!: number;
  idCra!: number;
  clickCount: number = 0;
  /* string */
  mode: string = 'addActivity';
  searchValue: string = '';
  searchElement: string = '';
  pagination : boolean =false;
  isLoadSpinner: boolean = true;

  /* array */
  listCra: any[] = [];
  familyTypes = [
    { id: '1', name: 'Production ' },
    { id: '2', name: 'Absence' },
    { id: '3', name: 'Interne' },
  ];
  /* formGroup */
  createLineCra: FormGroup = this.createLineCraForm();
  /* modal */
  modalRef?: BsModalRef;
  company_id: any;
  /* subscriprion */
  private unsubscribeAll: Subject<void> = new Subject();

  startSearching:boolean = false;

  constructor(
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private activityCra: EsnEvaluationService,
    private formBuilder: FormBuilder,
    private modalService: BsModalService,
    private localStorageService: LocalStorageService
  ) {}
  /* init */
  ngOnInit() {
    this.company_id = this.localStorageService.getData('clientConnected');
    this.getListAccounts();
  }

  getListAccounts() {
    let data = {
      per_page: this.pageSize,
      page: this.currentPage,
    };
    this.spinner.show();
    this.activityCra
      .getListCra(data)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          if (res.status == 200) {
            this.isLoadSpinner = false;

            this.spinner.hide();
            this.listCra = res.data.items.data;

            this.totalItems = res.data.items.total;
          }
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }
  /* create add subCategory form */
  createLineCraForm(data?: any) {
    return this.formBuilder.group({
      name: [
        data ? data.name : '',
        [Validators.required],
        this.maxLengthValidator(50),
      ],

      family: [
        data
          ? data.family == 'Absence'
            ? '2'
            : data.family == 'Interne'
            ? '3'
            : '1'
          : null,
        [Validators.required],
      ],
      company_id: [this.localStorageService.getData('clientConnected')],
    });
  }
  maxLengthValidator(maxLength: number): ValidatorFn {
    return (control: AbstractControl): Promise<ValidationErrors | null> => {
      return new Promise((resolve) => {
        const value = control.value as string;
        if (value && value.length > maxLength) {
          resolve({ maxLengthExceeded: true });
        } else {
          resolve(null);
        }
      });
    };
  }
    onPageChange(e: PageEvent): void {
      this.pageSize = e.pageSize;
      this.currentPage = e.pageIndex;
      if (this.btnSearchactive) {
        this.applyFilter(this.currentPage);
      } 
      else {
        this.getListAccounts();
      }
    }
  onReset(){
    this.currentPage=0;
    this.getListAccounts()
 } 
  submitData() {
    if (this.mode == 'addActivity') {
      this.addAccount();
    } else {
      this.updateAccount();
    }
  }
  addAccount() {
    this.spinner.show();
    const payload = {
      name : this.createLineCra.get('name')?.value,
      family : this.createLineCra.get('family')?.value,
    }
    this.activityCra
      .addTypeActivity(payload)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          if (res.status == 200) {
            this.toastr.success(addedCra);
            this.getListAccounts();
            this.closeModal();
            this.spinner.hide();
            this.createLineCra.reset();
          }
        },
        error: (err) => {
          this.spinner.hide();
          if (err.error) {
            if (err.error.message && err.error.message['name'])
              this.toastr.info(existedCra);
          }
        },
      });
  }
  updateAccount() {
    this.spinner.show();

    const payload = {
      name : this.createLineCra.get('name')?.value,
      family : this.createLineCra.get('family')?.value,
    }
    this.activityCra
      .updateActivityCra(this.idCra, payload)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          if (res.status == 200) {
            this.toastr.success(updatedCra);
            this.getListAccounts();
            this.closeModal();
            this.spinner.hide();
            this.createLineCra.reset();
          }
        },
        error: (err) => {
          this.spinner.hide();
          if (err.error) {
            if (err.error.message && err.error.message['name'])
              this.toastr.info(existedCra);
          }
        },
      });
  }
  /* open delete alert */
  openDeleteAlert(cra: any) {
    Swal.fire({
      title: `${confirmDelete} cette activité ?`,
      icon: 'question',
      iconColor: '#ff0000',
      showCancelButton: true,
      confirmButtonColor: '#ff0000',
      confirmButtonText: 'Oui',
      cancelButtonText: 'Non',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        if (
          !cra.action_specific_type_of_cra ||
          cra.action_specific_type_of_cra.length === 0
        ) {
          this.deleteAccount(cra.id);
        } else {
          this.deleteAccount(
            cra.action_specific_type_of_cra[0].type_of_cra_specific_id
          );
        }
      } 
    });
  }
  /* delete cra */
  deleteAccount(id: number) {
    this.spinner.show();
    this.activityCra
      .deleteActivityCra(id)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          if (res.status == 200) {
            this.spinner.hide();
            this.getListAccounts();
            this.toastr.success(deletedCra);
          }
        },
        error: () => {
          this.spinner.hide();
          this.toastr.error(serverError);
        },
      });
  }
  /* filter data on key up input */
  applyFilter(pageNumber : number = this.currentPage) {
    this.btnSearchactive=true;
    if (this.searchElement != '' || this.clickCount) {
      this.clickCount++;
      let data = {
        searchTerm: this.searchElement.trim().toLowerCase(),
        per_page: this.pageSize,
        page: this.currentPage
      };
      this.spinner.show();
      this.activityCra
        .searchCra(data)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            this.listCra = res.data.items.data;
            this.totalItems = res.data.items.total;
            this.spinner.hide();
          },
          error: () => {
            this.spinner.hide();
            this.toastr.error(serverError);
          },
        });
    }
  }
  openModal(template: TemplateRef<any>, mode: string, cra?: any) {
    this.mode = mode;
    if (cra) {
      if (
        !cra.action_specific_type_of_cra ||
        cra.action_specific_type_of_cra.length === 0
      ) {
        this.idCra = cra.id;
        this.createLineCra = this.createLineCraForm(cra);
      } else {
        this.idCra = cra.action_specific_type_of_cra[0].type_of_cra_specific_id;
        this.createLineCra = this.createLineCraForm(
          cra.action_specific_type_of_cra[0]
        );
      }
    }
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
  }
  closeModal() {
    this.modalRef!.hide();
    this.createLineCra.reset();
  }
  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
}
